/**
 * Selects which HeroTopicFront layout to render.
 *
 * - `IMAGE`: featured-image layout — a facet background paired with a heading,
 *   body, optional CTA, and a featured side image (`HeroTopicFrontWithImage`).
 * - `TEXT`: text-forward layout — a facet background with a heading and rich
 *   content overlaid, no featured side image (`HeroTopicFrontWithText`).
 */
export enum HeroTopicFrontVariant {
  IMAGE = 'image',
  TEXT = 'text'
}
